import { i18n } from "@lingui/core";
import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router";

import { defaultLocale } from "./libs/lingui";
import { messages } from "./locales/fr-FR/messages.po";
import { router } from "./router";

// Activate the default locale (French) before the first render to avoid a
// flash of the untranslated (English) source. LocaleProvider switches to the
// user's locale afterwards if it differs.
i18n.load(defaultLocale, messages);
i18n.activate(defaultLocale);

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = ReactDOM.createRoot(document.querySelector("#root")!);

root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
